export const DECIMAL_SEPARATOR = ','
export const THOUSAND_SEPARATOR = ' '
